import { useTranslation } from 'react-i18next';
import { Loader } from '@components/ui/Loader/Loader';
import classes from './PageLoader.module.css';

interface IPageLoaderProps {
  /** i18n key for the aria-label (e.g. `reports.contractorAnalysis.titleFallback`). */
  ariaLabelKey: string;
}

/**
 * Shared loading state for analytics report pages. Renders a centered
 * loader with `role="status"` + `aria-busy="true"` so assistive
 * technology announces the loading state.
 */
export function PageLoader({ ariaLabelKey }: IPageLoaderProps) {
  const { t } = useTranslation();
  return (
    <div
      className={classes.state}
      role="status"
      aria-busy="true"
      aria-label={t(ariaLabelKey)}
    >
      <Loader />
    </div>
  );
}
